var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ClientHeader',{attrs:{"name":_vm.client,"clientId":_vm.clientId}}),_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }